import AppLogo from './app-logo';

export default AppLogo;